import { useLayoutEffect } from 'react';
/**
 * Keeps `--vw` and `--vh` up-to-date.
 *
 * These CSS variables are calculated from `window.innerWidth`/`.innerHeight`
 * for better control over mobile viewports.
 *
 * You can also use `var(--vw-100)` for `100vw` & `var(--vh-100)` for `100vh`.
 */
export function useViewportSizeUpdaterEffect() {
    useLayoutEffect(function assignSizeCSSVariables() {
        function onResize() {
            const width = window.visualViewport?.width ?? window.innerWidth;
            const height = window.visualViewport?.height ?? window.innerHeight;
            const root = document.documentElement.style;
            root.setProperty('--vw', `${width * 0.01}px`);
            root.setProperty('--vh', `${height * 0.01}px`);
            root.setProperty('--vw-100', `${width}px`);
            root.setProperty('--vh-100', `${height}px`);
        }
        onResize();
        window.addEventListener('resize', onResize);
        window.visualViewport?.addEventListener('resize', onResize);
        return () => {
            window.visualViewport?.removeEventListener('resize', onResize);
            window.removeEventListener('resize', onResize);
        };
    }, []);
}
